// Axios
import axios from 'axios';

// Data
import idConstants from '../data/idConstants';

export const REGION_CODE = process.env.REACT_APP_REGION?.toLowerCase();
export const CONTENT_LINK = `${process.env.REACT_APP_CDN_LINK}/assets/cms`;
const TENANT_ID = process.env.REACT_APP_SELLER_TENANT_ID;

const CONTENT_LANGUAGE = {
    EN: '/en.json',
    DE: '/de.json'
};

const SUB_DOMAIN = process.env.REACT_APP_SUB_DOMAIN ? '/' + process.env.REACT_APP_SUB_DOMAIN : '';
export const CONTENT_URL = `${CONTENT_LINK}/${TENANT_ID}${SUB_DOMAIN}/${REGION_CODE}`;

export const getContent = () => {
    return (dispatch) => {
        dispatch({ type: 'CONTENT_LOADER', payload: true });
        axios({
            method: 'GET',
            url: `${CONTENT_URL}${CONTENT_LANGUAGE.EN}`,
            headers: {
                'Content-Type': 'application/json'
            },
        })
            .then((response) => {
                dispatch({
                    type: 'SET_CONTENT',
                    payload: response?.data,
                });
                dispatch({
                    type: 'SET_CONTENT_SIDEBAR',
                    payload: response?.data?.components?.sidebar,
                });
                dispatch({
                    type: 'SHOW_API',
                    payload: response?.data?.components?.sidebar?.menu?.some(
                        (category) =>
                            category.hasSubMenu &&
                            category.subMenus.some((subMenu) => subMenu.name === idConstants.api.productCategoryName)
                    )
                });
            })
            .catch((error) => {
                const errorObject = {
                    data: {
                        message: idConstants.contentError,
                    },
                    status: error.response?.status
                };
                dispatch({
                    type: 'ERROR',
                    error: errorObject,
                });
            });                        
    };
};
